<template>
  <div class="file-grid">
    <!-- file format -->
    <div class="file-grid-item" v-for="(item, index) in fromList" :key="index">
      <div class="file-grid-item-box" :class="[item.checkbox && 'isSelected']"
        @mouseleave.stop="handleMouseLeave(index)">
        <img class="url" :src="item.thumbnailStr" :alt="item.old_filename" @mouseover.stop="handleMouseOver(index)" />
        <div class="hover" v-show="item.hoverShow">
          <div class="hover-box">
            <button class="hover-box-item" v-for="(optionsItem, optionsIndex) in options.editList" :key="optionsIndex"
              @click="handlerClick(optionsItem.value, item)" v-show="btnHidden(optionsItem.value, item)">
              <div class="hover-box-item-box">
                <img :src="optionsItem.icon" alt="" />
                <span :class="[
                  optionsItem.color == 'default'
                    ? 'text-default'
                    : 'text-warning',
                ]">
                  {{ optionsItem.label }}
                </span>
              </div>
            </button>
          </div>
        </div>
        <div class="edit">
          <el-checkbox v-show="!item.hasOwnProperty('percentage') &&
            (item.hoverShow || item.checkbox)
            " v-model="item.checkbox" @change="checkboxChange(item, index)"></el-checkbox>
        </div>
        <fileEditDropdown class="edit-dropdown" :item="item" @fileChange="fileChange" type="grid"
          v-show="item.hoverShow" @pushUserMd5="pushUserMd5" @cancelDownload="cancelDownload" />
      </div>
      <div class="file-grid-item-text">
        <span class="name ellipsis" :title="item.old_filename">{{ item.old_filename }}</span>
        <span class="size">{{ item.sizeStr }}</span>
      </div>
      <!-- <div class="file-grid-item-state">
        {{ $t('downloading_text') }}，40%
      </div> -->
      <!-- 上传中 -->
      <div class="file-grid-item-state" v-show="item.hasOwnProperty('percentage')">
        {{ $t("uploading") }}，{{ item.percent || 0 }}%
      </div>
      <!-- 下载中 -->
      <div class="file-grid-item-state" v-show="item.fileStateStr == 'download'">
        {{ $t("downloading_text") }}，{{ item.downloadPercent || 0 }}%
      </div>
      <!-- 已下载 -->
      <div class="file-grid-item-state" v-show="item.fileStateStr == 'import'">
        {{ $t("downloaded") }}
      </div>
    </div>
  </div>
</template>
<script>
import fileEditDropdown from "./fileEditDropdown";
import { isMacOS, isLinux, isWindows } from "@/utils/platform";
export default {
  name: "fileGrid",
  components: { fileEditDropdown },
  props: {
    fromList: {
      type: Array,
      default: () => [],
    },
  },
  // watch: {
  //   fromList: {
  //     handler (val) {
  //       console.log(val);

  //     }
  //   }
  // },
  data () {
    return {
      options: {
        editList: [
          {
            label: this.$t("view_details"),
            value: "openView",
            icon: require(`@/assets/imgs/cloudSpace/view.webp`),
            color: "default",
          },
          {
            label: this.$t("import_model"),
            value: "Import",
            icon: require(`@/assets/imgs/cloudSpace/Import-click.webp`),
            color: "warning",
          },
          {
            label: this.$t("download_now"),
            value: "download",
            icon: require(`@/assets/imgs/cloudSpace/download-click-small.webp`),
            color: "default",
          },
        ],
      },
    };
  },
  created () {
    // mac下展示隐藏掉导入按钮
    // const type = this.$common.getSliceType()
    // if (type !== "win") {
    //   this.options.editList = this.options.editList.splice(2, 1)
    // }
  },
  computed: {
    btnHidden () {
      return (str, obj) => {
        let faild = false;
        const type = obj.file_extension?.toLowerCase();
        const arr = ["3mf", "gcode", "stl", "step", "svg", "obj", "amf"];
        switch (str) {
          case "openView":
            faild = type == "gcode" ? true : false;
            break;
          case "Import":
            faild =
              obj.fileStateStr == "import"
                ? arr.includes(type) || obj.file_type == 2
                  ? true
                  : false
                : false;
            break;
          case "download":
            faild = obj.fileStateStr == "default";
            break;
        }
        return faild;
      };
    },
  },
  methods: {
    pushUserMd5 (str, newKey, oldKey, value) {
      this.$emit("pushUserMd5", str, newKey, oldKey, value);
    },
    handleMouseOver (index) {
      if (
        this.fromList[index].percentage == 0 ||
        this.fromList[index].percentage == 1
      )
        return;
      this.$emit(
        "fileChange",
        "update",
        Object.assign(this.fromList[index], { hoverShow: true })
      );
    },
    handleMouseLeave (index) {
      if (
        this.fromList[index].percentage == 0 ||
        this.fromList[index].percentage == 1
      )
        return;
      this.$emit(
        "fileChange",
        "update",
        Object.assign(this.fromList[index], { hoverShow: false })
      );
    },
    checkboxChange (obj) {
      this.$emit("fileChange", "update", obj);
    },
    fileChange (str, obj) {
      this.$emit("fileChange", str, obj);
    },
    cancelDownload (id) {
      this.$emit("cancelDownload", id);
    },
    handlerClick (str, obj) {
      switch (str) {
        case "openView":
          this.$emit("openViewInfo", obj);
          break;
        case "Import":
          this.$emit("importModel", obj);
          break;
        case "download":
          this.$emit("fileDownload", [obj]);
          break;
      }
    },
  },
};
</script>
<style scoped lang="scss">
.file-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  &-item {
    width: calc((100% - 48px) / 7);
    min-height: calc((100% - 48px) / 7 + 50px);

    &-box {
      margin-bottom: 8px;
      position: relative;
      width: 100%;
      height: 214px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 6px;
      border: 1px solid var(--dialog-background-color);
      border-radius: 6px;

      .url {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 6px;
        background: var(--print-setting-background-color);
      }

      // .isSelected {
      //   border: 1px solid var(--VI-color);
      // }

      .edit {
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: absolute;
        top: 6px;
        width: 100%;
        padding: 12px 18px 0;
        z-index: 100;
        // margin-top: 12px;
      }

      .hover {
        background: rgba(0, 0, 0, 0.12);
        height: calc(100% - 12px);
        width: calc(100% - 12px);
        position: absolute;
        top: 6px;
        left: 6px;
        z-index: 10;
        display: flex;
        flex-direction: column;
        justify-content: center;
        border-radius: 6px;

        &-box {
          // padding: 63px 45px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          row-gap: 10px;

          &-item {
            margin: auto;
            padding: 6px 16px;
            border-radius: 16px;
            border: none;
            cursor: pointer;

            &-box {
              display: flex;
              align-items: center;
              column-gap: 4px;
              font-size: 14px;
              line-height: 16px;

              .text-default {
                color: #3986ff;
                white-space: nowrap;
              }

              .text-warning {
                color: #ff6700;
                white-space: nowrap;
              }
            }
          }
        }
      }

      .edit-dropdown {
        position: absolute;
        top: 8px;
        right: 14px;
        z-index: 200;
      }
    }

    .isSelected {
      border: 1px solid var(--VI-color);
    }

    &-text {
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      line-height: 22px;
      padding: 0 6px;

      .name {
        color: var(--first-text-color);
        max-width: 100px;
      }

      .size {
        color: var(--three-text-color);
      }
    }

    &-state {
      color: #438dff;
      font-size: 14px;
      line-height: 20px;
      padding: 0 6px;
    }
  }
}

// @media screen and (max-width: 815px) {
//   .GuideBlock {
//     width: calc(50% - 12px);
//     cursor: pointer;
//   }
// }

// @media screen and (min-width:816px) and (max-width:1087px) {
//   .GuideBlock {
//     width: calc(33% - 20px);
//     cursor: pointer;
//   }
// }

@media screen and (min-width:786px) and (max-width:923px) {
  .file-grid-item {
    width: calc((100% - 8px) / 2);
    min-height: calc((100% - 8px) / 2 + 50px);
  }
}

@media screen and (min-width:924px) and (max-width:1145px) {
  .file-grid-item {
    width: calc((100% - 16px) / 3);
    min-height: calc((100% - 16px) / 3 + 50px);
  }
}

@media screen and (min-width:1146px) and (max-width:1367px) {
  .file-grid-item {
    width: calc((100% - 24px) / 4);
    min-height: calc((100% - 24px) / 4 + 50px);
  }
}

@media screen and (min-width:1368px) and (max-width:1599px) {
  .file-grid-item {
    width: calc((100% - 32px) / 5);
    min-height: calc((100% - 32px) / 5 + 50px);
  }
}

@media screen and (min-width:1600px) and (max-width:1799px) {
  .file-grid-item {
    width: calc((100% - 40px) / 6);
    min-height: calc((100% - 40px) / 6 + 50px);
  }
}

@media screen and (min-width:1800px) and (max-width:1960px) {
  .file-grid-item {
    width: calc((100% - 48px) / 7);
    min-height: calc((100% - 48px) / 7 + 50px);
  }
}

.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
